import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'

export default function AgreementDownloadLink ({ downloadUrl }) {
  if (!downloadUrl) return null

  return (
    <a
      className={styles.downloadSignedBtn}
      href={downloadUrl}
      target='_blank'
      rel='noopener noreferrer'>
      Download signed copy
    </a>
  )
}

AgreementDownloadLink.propTypes = {
  downloadUrl: PropTypes.string
}
